// @flow
export const HEADER_DEFAULT_HEIGHT = 64;
export const HEADER_ICON_SIZE = 22;
export const HEADER_ID = 'HeaderContent';
export const HEADER_MESSAGE_BOTTOM_MARGIN = 4;
export const HEADER_MESSAGE_MIN_HEIGHT = 24; // should be consistent with $headerMessageHeight
export const HEADER_ZINDEX = 671;
export const HEADER_STYLE = {
  headerMessage: {
    __style: {
      marginBottom: HEADER_MESSAGE_BOTTOM_MARGIN,
    },
  },
};

export default null;
